module.exports = __webpack_public_path__ + "img/emoji-party.bef9ec8a.webp";